<template>
  <main id="main">
    <section>
      <div class="wrapper">
        <div class="hold-list">
          <div class="hold-list__route">
            <span>Total Routes</span>
            <b>{{title_cnt.route_cnt}}</b>
          </div>
          <div class="hold-list__distance">
            <span>Total Route Distance</span>
            <b>{{title_cnt.route_length}}km</b>
          </div>
          <div class="hold-list__driver">
            <span>Total Drivers</span>
            <b>{{title_cnt.driver_cnt}}</b>
          </div>
        </div>

        <div class="driver-pattern-score">
          <div class="driver-pattern-chart score">
            <h2 class="title-style-1">Driving Score</h2>
            <div class="driver-pattern-chart__select">
              <select class="select-style-2" @change="change_route($event)" name="" id="">
                <option value="0">All Routes</option>
                <option v-for="data in route_list" :key="data.idx" :value="data.idx">{{data.route_nm}}</option>
              </select>
            </div>
            <div class="driver-pattern-chart__container">
              <div class="container">
                <div id="anychart" class="chart" ref="anychart"></div>
              </div>
              <div class="legend c1">
                <ul>
                  <li>
                    <div></div>
                    <span>Driving Score</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="driver-pattern-score__value down">
            <h2 class="title-style-1">Score Decline</h2>
            <div class="driver-pattern-score__list">
              <ul>
                <li :key=i v-for="(data, i) in down_driver">
                  <div>
                    <div class="profile">
                      <img src="@/assets/images/icon/driver-pattern-score-list-icon.png" alt="">
                      <span>{{ data.driver_name }}</span>
                    </div>
                    <div class="score">
                      <span>{{ data.driver_point }}</span>
                      <img src="@/assets/images/icon/driver-pattern-score-list-down.png" alt="">
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="driver-pattern-chart pattern">
            <h2 class="title-style-1">Driving Pattern by Driver</h2>
            <div class="driver-pattern-chart__select">
              <select name="" id="" @change="change_driver($event)" class="select-style-2">
                <option value="0">All Drivers</option>
                <option v-for="data in driver_list" :key="data.driver_id" :value="data.driver_id">{{data.driver_name}}</option>
              </select>
            </div>
            <div class="driver-pattern-chart__container">
              <div class="container">
                <div id="anychart2" class="chart" ref="anychart2"></div>
              </div>
              <div class="legend">
                <ul>
                  <li>
                    <div></div>
                    <span>Rapid Accel</span>
                  </li>
                  <li>
                    <div></div>
                    <span>Rapid Decel</span>
                  </li>
                  <li>
                    <div></div>
                    <span>E-Stop</span>
                  </li>
                  <li>
                    <div></div>
                    <span>DoD Change</span>
                  </li>
                  <li>
                    <div></div>
                    <span>Battery Output</span>
                  </li>
                  <li>
                    <div></div>
                    <span>Cabin Temp.</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="driver-pattern-score__value up">
            <h2 class="title-style-1">Score Increase</h2>
            <div class="driver-pattern-score__list">
              <ul>
                <li :key=i v-for="(data, i) in up_driver">
                  <div>
                    <div class="profile">
                      <img src="@/assets/images/icon/driver-pattern-score-list-icon.png" alt="">
                      <span>{{ data.driver_name }}</span>
                    </div>
                    <div class="score">
                      <span>+{{ data.driver_point }}</span>
                      <img src="@/assets/images/icon/driver-pattern-score-list-up.png" alt="">
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="driver-pattern-tbl">
          <div class="tbl-wrapper">
            <table>
              <thead>
                <tr>
                  <th>Driver</th>
                  <th>Route No.</th>
                  <th>Vehicle No.</th>
                  <th>Overall Grade</th>
                  <th>Rapid Accel</th>
                  <th>Rapid Decel</th>
                  <th>E-Stop</th>
                  <th>DoD Change</th>
                  <th>Battery Output</th>
                  <th>Cabin Temp.</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="data in driver_table_list" :key="data.driver_id" v-on:click="get_popup_data(data.driver_id, data.user_name, data.route_name, data.car_number)" @click="showPopup">
                  <td>{{ data.user_name}}</td>
                  <td>{{ data.route_name}}</td>
                  <td>{{ data.car_number}}</td>
                  <td class="scoreA">A</td>
                  <td class="scoreA">{{ data.car_rapid_accel }}</td>
                  <td class="scoreA">{{ data.car_rapid_decel }}</td>
                  <td class="scoreA">{{ data.car_sudden_stop}}</td>
                  <td class="scoreC">{{ data.bat_dod }}</td>
                  <td class="scoreA">{{ data.bat_discharge_crate}}</td>
                  <td class="scoreB">{{ data.car_inside_temperature}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
    
    <div :class="'popup' + (popupFlag ? ' active' : '')">
      <div class="popup__contents">
        <div class="popup__back-btn">
          <button type="button" @click="popupFlag = false">Go Back</button>
        </div>

        <div class="popup__contents__container">
          <div class="container-column">
            <div class="container1">
              <h3 class="title-style-1">{{ popup_basic_data.user_name }}</h3>
              <section>
                <div class="photo">
                  <img src="@/assets/images/driver-photo-sample.png" alt="">
                </div>
                <div class="info">
                  <ul>
                    <li>
                      <p>{{ popup_basic_data.route_name }}</p>
                      <span>{{ popup_basic_data.car_number }} </span>
                    </li>
                    <li>
                      <p>Employee No.</p>
                      <span>{{ popup_data1.ei_number }}</span>
                    </li>
                    <li>
                      <p>Route Distance</p>
                      <span>{{ popup_data1.route_length }}km</span>
                    </li>
                    <li>
                      <p>Cumulative Days</p>
                      <span>{{ popup_data1.count_drive }}</span>
                    </li>
                    <li>
                      <p>Last Quarter Grade</p>
                      <span>A</span>
                    </li>
                  </ul>
                </div>
              </section>
            </div>
            <div class="container2">
              <h3 class="title-style-1">Avg. Speed Analysis</h3>
              <section>
                <div class="chart">
                  <div id="gauge">
                    <Gauge v-if="popupFlag" :rank="55" />
                  </div>
                  <div class="desc">
                    Driving <span>slightly faster</span> than the overall route average.
                  </div>
                </div>
                <div class="info">
                  <p class="text">
                    <span class="err1">Rapid acceleration count is higher than route average.</span>
                    <span class="err2">Driving habit management is recommended.</span>
                  </p>
                  <p class="box">
                    Rapid accel/decel reduces battery life.<br/>
                    Please share route-specific driving guidelines.<br/>
                    Please conduct basic safety training.
                  </p>
                </div>
              </section>
            </div>
          </div>
          <div class="container3">
            <div class="select">
              <select name="" id="" @change="get_popup_chart_data()" ref="popup_chart_option" class="select-style-1">
                <option value="0">Today</option>
                <option value="1">This Month</option>
                <option value="2">Cumulative</option>
              </select>
            </div>
            <div class="container-chart">
                <div id="anychart3" class="chart" ref="anychart3"></div>
              <div class="legend">
                <ul>
                  <li>
                    <div></div>
                    <span>{{ popup_basic_data.route_name }}</span>
                  </li>
                  <li>
                    <div></div>
                    <span>{{ popup_basic_data.user_name }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="month" ref="mobMonth">
              <section class="active">
                <h4 @click="mobMonthTab">This Month</h4>
                <ul>
                  <li>
                    <p>Total Trips</p>
                    <span>{{ popup_statistic[0].driving_cnt }}</span>
                  </li>
                  <li>
                    <p>Total Distance</p>
                    <span>{{ popup_statistic[0].car_odo_meter }}km</span>
                  </li>
                  <li>
                    <p>Rapid Accel Count</p>
                    <span>{{ popup_statistic[0].car_rapid_accel }}</span>
                  </li>
                  <li>
                    <p>Rapid Accel Status</p>
                    <span>{{ popup_statistic[0].car_rapid_accel_status }}</span>
                  </li>
                  <li>
                    <p>Rapid Decel Count</p>
                    <span>{{ popup_statistic[0].car_rapid_decel }}</span>
                  </li>
                  <li>
                    <p>Rapid Decel Status</p>
                    <span>{{ popup_statistic[0].car_rapid_decel_status }}</span>
                  </li>
                </ul>
              </section>
              <section>
                <h5 @click="mobMonthTab">Per 10km<br/>Avg. Count</h5>
                <ul>
                  <li>
                    <p>Rapid Accel Count</p>
                    <span>0.1</span>
                  </li>
                  <li>
                    <p>Company Avg.</p>
                    <span>0.12</span>
                  </li>
                  <li>
                    <p>Rapid Decel Count</p>
                    <span>0.75</span>
                  </li>
                  <li>
                    <p>Company Avg.</p>
                    <span>0.50</span>
                  </li>
                </ul>
              </section>
              <section>
                <h4 @click="mobMonthTab">Cumulative</h4>
                <ul>
                  <li>
                    <p>Total Trips</p>
                    <span>{{ popup_statistic[1].driving_cnt }}</span>
                  </li>
                  <li>
                    <p>Total Distance</p>
                    <span>{{ popup_statistic[1].car_odo_meter }}km</span>
                  </li>
                  <li>
                    <p>Rapid Accel Count</p>
                    <span>{{ popup_statistic[1].car_rapid_accel }}</span>
                  </li>
                  <li>
                    <p>Rapid Accel Status</p>
                    <span>{{ popup_statistic[1].car_rapid_accel_status }}</span>
                  </li>
                  <li>
                    <p>Rapid Decel Count</p>
                    <span>{{ popup_statistic[1].car_rapid_decel }}</span>
                  </li>
                  <li>
                    <p>Rapid Decel Status</p>
                    <span>{{ popup_statistic[1].car_rapid_decel_status }}</span>
                  </li>
                </ul>
              </section>
              <section>
                <h5 @click="mobMonthTab">Per 10km<br/>Avg. Count</h5>
                <ul>
                  <li>
                    <p>Rapid Accel Count</p>
                    <span>0.1</span>
                  </li>
                  <li>
                    <p>Company Avg.</p>
                    <span>0.12</span>
                  </li>
                  <li>
                    <p>Rapid Decel Count</p>
                    <span>0.75</span>
                  </li>
                  <li>
                    <p>Company Avg.</p>
                    <span>0.50</span>
                  </li>
                </ul>
              </section>
            </div>
          </div>
          <div class="container4">
            <section class="heater">
              <div class="temp">
                <div class="view">
                  <ul>
                    <li>
                      <div class="icon">
                        <img src="@/assets/images/icon/heater-small.png" alt="">
                      </div>
                      <span>Heater Temp.</span>
                      <p>{{ popup_temperature['car_heater_temperature'] }}&#176;</p>
                      <i>&nbsp;</i>
                    </li>
                    <li>
                      <div class="icon">
                        <img src="@/assets/images/icon/temp-small.png" alt="">
                      </div>
                      <span>Current Temp.</span>
                      <p>{{ popup_temperature['car_aircon_temperature'] }}&#176;</p>
                      <i>Power Usage: 10kWh</i>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="btn">
                <input type="checkbox" name="" ref="changeAirBtn" id="changeAirBtn" class="hidden">
                <label for="changeAirBtn">
                  <div>
                    <span>A/C Mode</span>
                    <p></p>
                    <span>Heater Mode</span>
                  </div>
                </label>
              </div>
            </section>
            <div class="icon">
              <p>Heater Status</p>
              <img src="@/assets/images/driver-temperature-good.png" alt="">
              <span>Operating normally.</span>
            </div>
            <div class="info">
              <table>
                <colgroup>
                  <col style="width: 22%;">
                  <col style="width: 28%;">
                  <col style="width: 28%;">
                  <col style="width: 22%;">
                </colgroup>
                <thead>
                  <tr>
                    <th></th>
                    <th>Required Cabin Temp.</th>
                    <th>Min. Cabin Temp.</th>
                    <th>Outdoor Temp.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>Temp.</th>
                    <td>18&#176;C</td>
                    <td>16&#176;C</td>
                    <td>25&#176;C</td>
                  </tr>
                  <tr>
                    <th>Power Usage</th>
                    <td>Power Saved</td>
                    <td>20kwh</td>
                    <td>-</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import anychart from 'anychart'
import Gauge from '@/components/page/DriverPatternGauge'

export default {
  name: 'DriverPattern',

  components: {
    Gauge
  },

  data () {
    return {
      popupFlag: false,
      title_cnt: 
        {
          route_cnt: 0,
          route_length: 0,
          driver_cnt: 0,
        },
      route_option: 0,
      route_list: '',
      up_driver: '',
      down_driver: '',
      driver_option: 0,
      driver_list: '',
      driver_table_list: '',
      popup_basic_data: '',
      popup_data1: '',
      popup_statistic: [
        {
          driving_cnt: 0,
          car_odo_meter: 0,
          car_rapid_accel: 0,
          car_rapid_decel: 0,
          car_rapid_accel_status: 0,
          car_rapid_decel_status: 0,
        },
        {
          driving_cnt: 0,
          car_odo_meter: 0,
          car_rapid_accel: 0,
          car_rapid_decel: 0,
          car_rapid_accel_status: 0,
          car_rapid_decel_status: 0,
        },
      ],
      popup_temperature: '',
    }
  },

  watch: {
    changeAirBtn: function(){
      this.set_popup_temperature();
    },
  },

  mounted (){
    this.get_title_cnt(); // 타이틀 데이터 가져오기
    this.get_route_list(); // 라우트 정보 가져오기
    this.get_chart1_data(); // 운전점수 차트 가져오기
    this.get_chart2_data(); // 운전점수 차트 가져오기
    this.get_table_driver_list(); // 운전자 테이블 가져오기
    this.get_driver_list(); // 노선에 해당하는 운전자 목록 가져오기
  },

  methods: {
    set_popup_temperature: function(){
      // changeAirBtn
    },

    // 팝업데이터 가져오기
    get_popup_data: function(driver_id, user_name, route_name, car_number){
      var arr = new Array();
      arr['driver_id'] = driver_id;
      arr['user_name'] = user_name;
      arr['route_name'] = route_name;
      arr['car_number'] = car_number;
      this.popup_basic_data = arr;

      var post_data = {driver_id: driver_id, route_name: route_name ,group_id: this.$store.getters.getGroupId}
      this.$axios.post('/api/driver_get_popup_data', post_data).then(res => {
        this.popup_data1 = res.data.result[0];
        this.popup_statistic = res.data.result[1];
        this.popup_temperature = res.data.result[2];

        this.get_popup_chart_data();
      });
    },

    // 팝업데이터 차트 조회
    get_popup_chart_data: function(){
      var post_data = {popup_chart_option: this.$refs.popup_chart_option.value ,driver_id: this.popup_basic_data['driver_id'], route_name: this.popup_basic_data['route_name'] ,group_id: this.$store.getters.getGroupId}
      this.$axios.post('/api/driver_get_popup_chart_data', post_data).then(res => {
        this.anychart3(res.data.result[0]);
      });
    },

    // 운전자 테이블 가져오기
    get_table_driver_list: function(){
      var post_data = {driver_option: this.driver_option ,route_option: this.route_option, group_id: this.$store.getters.getGroupId}
      this.$axios.post('/api/driver_get_table_driver_list', post_data).then(res => {
        this.driver_table_list = res.data.result[0];
      });
    },

    // 차트 데이터 가져오기
    get_chart1_data: function(){
      var post_data = {driver_option: this.driver_option ,route_option: this.route_option, group_id: this.$store.getters.getGroupId}
      this.$axios.post('/api/driver_get_chart_data', post_data).then(res => {
        this.up_driver = res.data.result[1];
        this.down_driver = res.data.result[2];
        
        this.anychart1(res.data.result[0]);
      });
    },

    // 차트 데이터 가져오기
    get_chart2_data: function(){
      var post_data = {driver_option: this.driver_option ,route_option: this.route_option, group_id: this.$store.getters.getGroupId}
      this.$axios.post('/api/driver_get_chart2_data', post_data).then(res => {
        this.anychart2(res.data.result[0]);
      });
    },

    // 노선에 해당하는 운전자리스트 가져오기
    get_driver_list: function(){
      var post_data = {route_option: this.route_option, group_id: this.$store.getters.getGroupId}
      this.$axios.post('/api/driver_get_driver_list', post_data).then(res => {
        this.driver_list = res.data.rows;
      });
    },
    
    // 노선 목록 조회
  get_route_list () {
    var post_data = {group_id: this.$store.getters.getGroupId};
    this.$axios.post('/api/get_route_list', post_data).then(res => {
      this.route_list = res.data.rows;
    });
     },

     // 옵션 선택시 데이터 새로 설정
  change_route (event){
    this.route_option = event.target.value; // 라우터 옵션 값 변경

       this.get_title_cnt(); // 타이틀 데이터 가져오기
       this.get_driver_list(); // 노선에 해당하는 운전자 목록 가져오기
       this.get_chart1_data(); // 운전점수 차트 데이터 가져오기
       this.get_chart2_data(); // 운전점수 차트 데이터 가져오기
       this.get_table_driver_list(); // 운전자 테이블 가져오기
       this.get_driver_list(); // 노선에 해당하는 운전자 목록 가져오기
     },

     // 운전사 선택시 데이터 새로 설정
  change_driver (event){
    this.driver_option = event.target.value; // 라우터 옵션 값 변경

       this.get_chart2_data(); // 운전점수 차트 데이터 가져오기
     },

    anychart1: function (datas) {
      this.$refs.anychart.innerHTML = "";
      anychart.onDocumentReady(() => {
        // create line chart
        var chart = anychart.line();
        chart.noData().label().enabled(true);
        chart.noData().label().text("No Data");
    
        // set chart padding
        chart.padding([10, 20, 5, 20]);

        // turn on chart animation
        chart.animation(true);

        // turn on the crosshair
        //chart.crosshair(true);

        // set chart title text settings
        //chart.title('운전 점수');

        // set y axis title
        //chart.yAxis().title('Activity occurrences');

        var extraYScale = anychart.scales.linear();
        extraYScale.minimum(0);
        extraYScale.maximum(100);
        extraYScale.ticks().interval();
        extraYScale.minorTicks().interval(50);

        // set scale for the chart, this scale will be used in all scale dependent entries such axes, grids, etc
        chart.yScale(extraYScale);

        // create data set on our data,also we can pud data directly to series
        var dataSet = anychart.data.set(datas);

        // map data for the first series,take value from first column of data set
        var firstSeriesData = dataSet.mapAs({ x: 0, value: 1 });

        // temp variable to store series instance
        var series;

        // setup first series
        series = chart.line(firstSeriesData);
        series.name('Driving Score');
        // enable series data labels
        series.labels().enabled(true).anchor('left-bottom').padding(5);
        // enable series markers
        series.markers(true);

        // grid set
        chart.yGrid(true);
        
        // turn the legend on
        chart.legend().enabled(false).fontSize(13).padding([0, 0, 20, 0]);
        
        // 차트 색 정리
        var palette = anychart.palettes.rangeColors();
        palette.items([{ color: '#e77011' }]);
        chart.palette(palette);
        
        //워터마커 제거
        anychart.licenseKey("4dream-8254134a-23a23715");
        var credits = chart.credits();
        credits.enabled(false);

        // set container for the chart and define padding
        chart.container('anychart');
        // initiate chart drawing
        chart.draw();
      });
    },

    anychart2: function (data) {
      this.$refs.anychart2.innerHTML = "";
      anychart.onDocumentReady(() => {
        // create line chart
        var chart = anychart.line();
        chart.noData().label().enabled(true);
    chart.noData().label().text("No Data");
        // set chart padding
        chart.padding([10, 20, 5, 20]);

        // turn on chart animation
        chart.animation(true);

        // turn on the crosshair
        //chart.crosshair(true);

        // set chart title text settings
        //chart.title('Customers Activity during the Week');

        // set y axis title
        //chart.yAxis().title('Activity occurrences');

        var extraYScale = anychart.scales.linear();
        extraYScale.minimum(0);
        extraYScale.maximum(100);
        extraYScale.ticks().interval();
        extraYScale.minorTicks().interval(50);

        // set scale for the chart, this scale will be used in all scale dependent entries such axes, grids, etc
        chart.yScale(extraYScale);

        var dataSet = anychart.data.set(data);

        //var d1 = dataSet.mapAs({ x: 0, value: 1 });
        var d2 = dataSet.mapAs({ x: 0, value: 2 });
        var d3 = dataSet.mapAs({ x: 0, value: 3 });
        var d4 = dataSet.mapAs({ x: 0, value: 4 });
        var d5 = dataSet.mapAs({ x: 0, value: 5 });
        var d6 = dataSet.mapAs({ x: 0, value: 6 });
        var d7 = dataSet.mapAs({ x: 0, value: 7 });

        // temp variable to store series instance
        var series;

        // 1
        /* series = chart.line(d1);
        series.name('종합등급');
        series.labels().enabled(true).anchor('left-bottom').padding(5);
        series.markers(true); */

        // 2
        series = chart.line(d2);
        series.name('Rapid Accel');
        series.labels().enabled(true).anchor('left-bottom').padding(5);
        series.markers(true);

        // 3
        series = chart.line(d3);
        series.name('Rapid Decel');
        series.labels().enabled(true).anchor('left-bottom').padding(5);
        series.markers(true);

        // 4
        series = chart.line(d4);
        series.name('E-Stop');
        series.labels().enabled(true).anchor('left-bottom').padding(5);
        series.markers(true);

        // 5
        series = chart.line(d5);
        series.name('DoD');
        series.labels().enabled(true).anchor('left-bottom').padding(5);
        series.markers(true);

        // 6
        series = chart.line(d6);
        series.name('Battery Output');
        series.labels().enabled(true).anchor('left-bottom').padding(5);
        series.markers(true);

        // 7
        series = chart.line(d7);
        series.name('Cabin Temp.');
        series.labels().enabled(true).anchor('left-bottom').padding(5);
        series.markers(true);

        // turn the legend on
        chart.legend().enabled(false).fontSize(13).padding([0, 0, 20, 0]);

        // grid set
        chart.yGrid(true);
        
        // 차트 색 정리
        var palette = anychart.palettes.rangeColors();
        palette.items([{ color: '#2a414e' }, { color: '#64c0ab' }, { color: '#33b48d' }, { color: '#189e90' }, { color: '#077c89' }, { color: '#096088' }]);
        chart.palette(palette);
        
        //워터마커 제거
        anychart.licenseKey("4dream-8254134a-23a23715");
        var credits = chart.credits();
        credits.enabled(false);

        // set container for the chart and define padding
        chart.container('anychart2');
        // initiate chart drawing
        chart.draw();
      });
    },

    anychart3: function (data) {
      this.$refs.anychart3.innerHTML = "";
      anychart.onDocumentReady(() => {
        // create data set on our data
        var dataSet = anychart.data.set(data);

        // map data for the first series, take x from the zero column and value from the first column of data set
        var firstSeriesData = dataSet.mapAs({ x: 0, value: 1 });

        // map data for the second series, take x from the zero column and value from the second column of data set
        var secondSeriesData = dataSet.mapAs({ x: 0, value: 2 });

        // create column chart
        var chart = anychart.column();

        // turn on chart animation
        chart.animation(true);

        //워터마커 제거
        anychart.licenseKey("4dream-8254134a-23a23715");
        var credits = chart.credits();
        credits.enabled(false);

        // create scale for line series and extraYAxis
        // it force line series to not stuck values with over series
        var scale = anychart.scales.linear();

        // create extra axis on the right side of chart
        chart
          .yAxis(0)
          .title('')
          .orientation('left')
          .scale(scale);

        // create second series with mapped data
        var columnSeries = chart.column(secondSeriesData);
        columnSeries.name('Route Avg.');

        // create third series with mapped data
        /* var splineSeries = chart.splineArea(thirdSeriesData);
        splineSeries.name('Spline'); */

        // create line series and set scale for it
        var lineSeries = chart.spline(firstSeriesData);
        lineSeries.name('Driving Score').yScale(scale).stroke('2.5 #ef6c00');
        lineSeries.yScale().minimum(0);
        lineSeries.yScale().maximum(100);

        chart.tooltip().displayMode('union');

        chart.interactivity().hoverMode('by-x');

        // turn the legend on
        chart.legend().enabled(false).fontSize(13).padding([0, 0, 10, 0]);

        // 단위
        chart.yAxis().title("Driving Score");
        //chart.yAxis(1).title("운전점수");

        // grid set
        chart.yGrid(true);

        // 차트 색상 수동설정
        var palette = anychart.palettes.rangeColors();
        palette.items([{ color: '#3aa083' }, { color: '#e0641f' }]);
        chart.palette(palette);
        
        // set container id for the chart
        chart.container('anychart3');

        // initiate chart drawing
        chart.draw();
      });
    },

    showPopup () {
      this.popupFlag = true
    },

    get_title_cnt(){
      var post_data = {group_id: this.$store.getters.getGroupId, route_option: this.route_option};
      this.$axios.post('/api/driver_get_title_cnt', post_data).then(res => {
        this.title_cnt = res.data.result[0];
      });
    },
    
    mobMonthTab (e) {
      if (window.innerWidth > 768) return;

      Array.from(this.$refs.mobMonth.children).reduce((_, cur) => {
        cur.classList.remove('active');
      }, null)

      const parent = e.target.parentElement;
      parent.classList.add('active');
    }
  }
}
</script>

<style lang="scss" scoped>
$defaultMargin: 25px;

#main {
  >section {
    padding: $defaultMargin;
    height: 100%;
    overflow-y: auto;
    @include mobile {
      padding: 10px;
    }
  }

  .wrapper {
    width: 100%;
    min-width: 1400px;
    min-height: 100%;
    position: relative;
    @include mobile {
      min-width: 100%;
    }
  }

  .driver-pattern-score {
    display: flex;
    flex-wrap: wrap;
    min-height: 870px;
    @include mobile {
      display: grid;
      grid-template-columns: 1fr;
      gap: 10px;
    }

    >div {
      background: #fff;
      border: 1px solid #979797;
      border-radius: 6px;
      position: relative;
      padding: 25px;
      @include mobile {
        padding: 10px;
      }
    }

    .driver-pattern-chart {
      width: calc(100% - 519px);
      margin-right: 25px;
      margin-bottom: 25px;
      border: 1px solid #979797;
      border-radius: 6px;
      position: relative;
      background: #fff;
      .title-style-1 {
        margin-bottom: 15px;
      }
      @include mobile {
        width: 100%;
        margin: 0;
        &.score {
          order: 1;
          .driver-pattern-chart__container .legend ul li {
            width: 100%;
            span {
              width: auto;
            }
          }
        }
        &.pattern {
          order: 4;
          margin-bottom: 10px;
        }
      }

      &__select {
        position: absolute;
        top: 25px;
        right: 25px;
        @include mobile {
          top: 13px;
          right: 10px;
        }
        select {
          width: 200px;
          height: 36px;
          font-size: 18px;
          background-size: 13px;
          @include mobile {
            width: 120px;
            height: 24px;
            padding-left: 10px;
            font-size: 14px;
          }
        }
      }

      &__container {
        width: 100%;
        height: calc(100% - 43px);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        @include mobile {
          height: 250px;
        }
        .container {
          width: 100%;
          height: 100%;
          @include mobile {
            height: calc(100% - 25px);
          }
          .chart {
            width: 100%;
            height: 100%;
          }
        }
        .legend {
          width: 100%;
          height: auto;
          padding: 10px 25px 0;
          text-align: center;
          @include mobile {
            padding: 0;
          }
          &.c1 {
            div {
              background: #e77011 !important;
            }
          }
          ul {
            width: auto;
            height: auto;
            border: 1px solid #271e1b;
            border-radius: 15px;
            display: inline-flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            align-items: center;
            padding: 6px 12px;
            @include mobile {
              padding: 3px 6px;
            }
            li {
              display: flex;
              align-items: center;
              justify-content: center;
              margin-right: 18px;
              &:nth-of-type(1) div { background: #2a414e; }
              &:nth-of-type(2) div { background: #64c0ab; }
              &:nth-of-type(3) div { background: #33b48d; }
              &:nth-of-type(4) div { background: #189e90; }
              &:nth-of-type(5) div { background: #077c89; }
              &:nth-of-type(6) div { background: #096088; }
              &:last-child { margin-right: 0; }
              @include mobile {
                width: calc(100% / 3);
                margin-right: 0;
              }
              div {
                width: 44px;
                height: 4px;
                border-radius: 2px;
                background: #000;
                position: relative;
                margin-right: 10px;
                @include mobile {
                  width: 33px;
                  height: 3px;
                }
                &::before {
                  $radius: 6px;
                  content: '';
                  @include mobile {
                    $radius: 5px;
                  }
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  width: calc(#{$radius} * 2);
                  height: calc(#{$radius} * 2);
                  border-radius: 50%;
                  background: inherit;
                }
              }
              span {
                font-size: 14px;
                color: #231916;
                font-weight: 700;
                white-space: nowrap;
                @include mobile {
                  display: block;
                  width: 63px;
                  font-size: 12px;
                }
              }
            }
          }
        }
      }
    }

    &__value {
      width: 494px;
      margin-bottom: 25px;
      @include mobile {
        width: 100%;
        margin-bottom: 0px;
      }
      &.down {
        .score span {
          color: #f20000;
        }
        @include mobile {
          order: 2;
        }
      }
      &.up {
        .score span {
          color: #3eadc7;
        }
        @include mobile {
          order: 3;
        }
      }
    }

    &__select {
      position: absolute;
      top: 25px;
      right: 25px;
      select {
        height: 36px;
        font-size: 18px;
        background-size: 13px;
      }
    }
    &__list {
      height: 316px;
      overflow: auto;
      @include mobile {
        height: 250px;
      }
      ul {
        li {
          width: 100%;
          height: 58px;
          border: 1px solid #ced8df;
          @include mobile {
            height: 45px;
          }
          &:not(:last-child) {
            margin-bottom: 4px;
          }
          >div {
            width: 100%;
            height: 100%;
            border: 1px solid #e5eaee;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 25px;
            font-weight: 600;
            @include mobile {
              padding: 0 10px;
            }
            img {
              @include mobile {
                width: 30px;
              }
            }
          }
          .profile {
            display: flex;
            align-items: center;
            span {
              margin-left: 24px;
              font-size: 18px;
              color: #022121;
              white-space: nowrap;
              @include mobile {
                font-size: 14px;
                margin-left: 12px;
              }
            }
          }
          .score {
            display: flex;
            align-items: center;
            span {
              margin-right: 8px;
              font-size: 25px;
              @include mobile {
                font-size: 20px;
              }
            }
            img {
              @include mobile {
                width: 25px;
              }
            }
          }
        }
      }
    }
  }

  .driver-pattern-tbl {
    width: 100%;
    min-width: 1400px;
    border-radius: 6px;
    position: relative;
    background: #fff;
    border: 1px solid #979797;
    padding: 25px;
    @include mobile {
      min-width: 100%;
      padding: 10px;
    }
    .tbl-wrapper {
      width: 100%;
      height: 440px;
      border-top: 5px solid #9e9e9e;
      overflow: auto;
      @include mobile {
        height: 300px;
      }
    }
    table {
      width: auto;
      min-width: 100%;
      height: auto;
      text-align: center;
      thead {
        position: sticky;
        top: 0;
        left: 0;
        background: #fff;
        tr {
          th {
            height: 42px;
            font-size: 20px;
            font-weight: 700;
            color: #077f80;
            @include mobile {
              height: 36px;
              font-size: 16px;
            }
          }
        }
      }
      tbody {
        tr {
          cursor: pointer;
          &:hover {
            background: #aee3cc;
          }
          td {
            height: 50px;
            font-size: 18px;
            font-weight: 600;
            min-width: 105px;
            @include mobile {
              height: 40px;
              font-size: 14px;
            }
            &.scoreA {
              color: #0aa678;
            }
            &.scoreB {
              color: #ed8b00;
            }
            &.scoreC {
              color: #dc0000;
            }
          }
        }
      }
      tr {
        border-bottom: 1px solid #9e9e9e;
      }
    }
  }
  
  .popup {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: none;
    overflow: auto;
    @include mobile {
      position: fixed;
      top: 50px;
      height: calc(100% - 50px);
    }
    &.active {
      display: block;
    }
    &__back-btn {
      width: 100%;
      height: 30px;
      margin-bottom: $defaultMargin;
      text-align: right;
      @include mobile {
        margin-bottom: 0;
        position: absolute;
        top: 21px;
        right: 20px;
      }
      button {
        width: 108px;
        height: 100%;
        border-radius: 3px;
        border: 1px solid #555;
        background: #fff url('~@/assets/images/icon/back.png') no-repeat right 10px center;
        font-size: 14px;
        color: #555;
        box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
        text-align: left;
        padding-left: 10px;
        @include mobile {
          font-size: 0;
          box-shadow: none;
          border: none;
          border-radius: none;
          background: url('~@/assets/images/icon/mob-close.png') no-repeat center;
          background-size: 100% 100%;
          width: 30px;
          height: 30px;
        }
      }
    }
    &__contents {
      z-index: 999;
      width: 100%;
      min-width: 1600px;
      height: 100%;
      padding: $defaultMargin;
      background: #f3f8f6;
      @include mobile {
        padding: 10px;
        min-width: 100%;
        height: auto;
      }
      &__container {
        width: 100%;
        overflow: auto;
        display: flex;
        @mixin default {
          border: 1px solid #5c5c5c;
          border-radius: 6px;
          padding: $defaultMargin;
          background: #fff;
        }
        @include mobile {
          flex-direction: column;
        }
        >div {
          margin-right: $defaultMargin;
          @include mobile {
            margin-right: 0;
            margin-bottom: 10px;
          }
          &:last-child {
            margin-right: 0;
            margin-bottom: 0;
          }
        }
        .container-column {
          width: 27%;
          @include mobile {
            width: 100%;
          }
          .container1 {
            width: 100%;
            margin-bottom: $defaultMargin;
            @include default;
            @include mobile {
              margin-bottom: 10px;
              padding: 10px;
            }
            section {
              width: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              >div {
                height: 100%;
                border: 1px solid #979797;
              }
              .photo {
                width: 240px;
                height: 173px;
                border-radius: 6px;
                position: relative;
                margin-bottom: $defaultMargin;
                @include mobile {
                  margin-bottom: 10px;
                }
                img {
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                }
              }
              .info {
                width: 100%;
                border-radius: 0 6px 6px 0;
                border-left: 10px solid #4dc1bf;
                overflow: hidden;
                ul {
                  width: 100%;
                  height: 100%;
                  li {
                    width: 100%;
                    height: 42px;
                    color: #022121;
                    font-weight: 600;
                    font-size: 12px;
                    display: flex;
                    border-bottom: 1px solid #a6978e;
                    &:nth-child(2n-1) { background: #f5f5f5; }
                    &:last-child { border-bottom: none; }
                    p {
                      width: 25%;
                      height: 100%;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      border-right: 1px solid #a6978e;
                    }
                    span {
                        width: 75%;
                        height: 100%;
                      display: flex;
                        align-items: center;
                      justify-content: center;
                    }
                  }
                }
              }
            }
          }
          .container2 {
            width: 100%;
            height: 280px;
            @include default;
            @include mobile {
              padding: 10px;
              height: 236px;
            }
            section {
              display: flex;
              justify-content: space-between;
              .chart {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                width: 150px;
                #gauge {
                  width: 130px;
                  height: 130px;
                  background: #f2f2f2;
                  margin-bottom: 6px;
                }
                .desc {
                  color: #022121;
                  font-weight: 600;
                  font-size: 12px;
                  word-break: keep-all;
                  text-align: center;
                  span {
                    color: #8fc42e;
                  }
                }
              }
              .info {
                width: 240px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .text {
                  padding-bottom: 5px;
                  span {
                    display: block;
                    margin-bottom: 5px;
                    font-size: 12px;
                    font-weight: 600;
                    padding-left: 20px;
                  }
                  .err1 {
                    background: url('~@/assets/images/icon/driver-pattern-popup-i.png') no-repeat center left;
                  }
                  .err2 {
                    background: url('~@/assets/images/icon/driver-pattern-popup-arrow.png') no-repeat center left 3px;
                  }
                }
                .box {
                  border: 1px solid #b3ced3;
                  border-radius: 6px;
                  padding: 5px 10px;
                  line-height: 22px;
                  font-size: 12px;
                  margin-bottom: 20px;
                }
              }
            }
          }
        }
        .container3 {
          position: relative;
          width: 43.7%;
          height: 822px;
          @include default;
          @include mobile {
            width: 100%;
            padding: 10px;
            height: 521px;
          }
          .select {
            margin-bottom: 15px;
            select {
              width: 150px;
              height: 36px;
              font-size: 18px;
              @include mobile {
                width: 100px;
                height: 24px;
                font-size: 12px;
              }
            }
          }
          .container-chart {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 100%;
            height: 340px;
            position: relative;
            margin-bottom: 50px;
            @include mobile {
              height: 260px;
              margin-bottom: 20px;
            }
            .chart {
              width: 100%;
              height: 100%;
            }
            .legend {
              border: 1px solid #271e1b;
              border-radius: 10px;
              padding: 5px 26px;
              ul {
                display: flex;
                li {
                  display: flex;
                  align-items: center;
                  line-height: 1;
                  &:first-child {
                    margin-right: 25px;
                  }
                  div {
                    width: 9px;
                    height: 9px;
                    background: #3aa083;
                    margin-right: 15px;
                    border-radius: 2px;
                  }
                  span {
                    font-size: 12px;
                    font-weight: 600;
                    white-space: nowrap;
                  }
                  &:nth-of-type(2) div {
                    background: #e0641f;
                    position: relative;
                    &::before {
                      content: '';
                      position: absolute; 
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      display: block;
                      width: 23px;
                      height: 2px;
                      border-radius: 2px;
                      background: inherit;
                    }
                  }
                }
              }
            }
          }
          .month {
            width: 100%;
            height: calc(100% - 441px);
            @include mobile {
              display: flex;
              position: relative;
              justify-content: space-between;
            }
            section {
              width: 100%;
              height: 25%;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              @include mobile {
                width: calc((100% - 30px) / 4);
                height: 50px;
                align-items: flex-start;
              }
              &.active {
                h4, h5 {
                  background: #7dc8bc;
                  color: #fff;
                  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.3);
                }
                ul {
                  display: flex;
                }
              }
              h4 {
                width: 49px;
                height: 47px;
                background: #7dc8bc;
                border-radius: 6px;
                color: #fff;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 15px;
                @include mobile {
                  width: 100%;
                  height: 100%;
                  background: #fff;
                  border: 1px solid #7dc8bc;
                  color: #79c0b5;
                }
              }
              h5 {
                width: 74px;
                height: 49px;
                border: 1px solid #7dc8bc;
                background: #eff7f7;
                border-radius: 6px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 13px;
                font-weight: 700;
                color: #1e1e1e;
                @include mobile {
                  width: 100%;
                  height: 100%;
                  background: #fff;
                  color: #79c0b5;
                }
              }
              ul {
                width: calc(100% - 72px);
                display: flex;
                margin-left: 23px;
                @include mobile {
                  display: none;
                  position: absolute;
                  top: 60px;
                  left: 0;
                  margin-left: 0;
                  border: 1px solid #979797;
                  padding: 10px;
                  padding-bottom: 0px;
                  border-radius: 4px;
                  width: 100% !important;
                  flex-wrap: wrap;
                }
                li {
                  width: calc(100% / 6);
                  font-weight: 600;
                  font-size: 13px;
                  text-align: center;
                  margin-right: 18px;
                  @include mobile {
                    width: calc(100% / 3) !important;
                    margin-right: 0;
                    margin-bottom: 10px;
                  }
                  p {
                    padding-bottom: 11px;
                    position: relative;
                    @include mobile {
                      padding-bottom: 5px;
                    }
                    &::after {
                      content: '';
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      display: block;
                      width: calc(100% + 18px);
                      height: 1px;
                      background: #5c5c5c;
                      @include mobile {
                        width: 100%;
                      }
                    }
                  }
                  span {
                    color: #e98900;
                    display: block;
                    padding-top: 10px;
                    @include mobile {
                      padding-top: 5px;
                    }
                  }
                  &:last-child {
                    margin-right: 0;
                    p::after {
                      width: 100%;
                    }
                  }
                }
              }
              &:nth-of-type(2n) {
                ul {
                  width: 70%;
                  li {
                    width: calc(100% / 4);
                  }
                }
              }
            }
          }
        }
        .container4 {
          width: 26.7%;
          height: 822px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: center;
          @include default;
          @include mobile {
            width: 100%;
            height: 660px;
            padding: 10px;
          }
          section {
            width: 100%;
            .temp {
              .view {
                width: 100%;
                ul {
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                  li {
                    width: calc((100% - #{$defaultMargin}) / 2);
                    height: 200px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    border-radius: 10px;
                    @include mobile {
                      width: calc((100vw - 60px) / 2);
                      height: 150px;
                    }
                    .icon {
                      width: 40px;
                      height: 40px;
                      border-radius: 6px;
                      box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.3);
                      background: #e4896e;
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      @include mobile {
                        width: 30px;
                        height: 30px;
                      }
                      img {
                        width: 80%;
                      }
                    }
                    span {
                      font-size: 22px;
                      font-weight: 600;
                      line-height: 1;
                      margin-top: 13px;
                      margin-bottom: 7px;
                      @include mobile {
                        font-size: 14px;
                        margin-bottom: 5px;
                      }
                    }
                    p {
                      font-size: 60px;
                      font-weight: 600;
                      line-height: 1;
                      letter-spacing: -0.05em;
                      margin-bottom: 11px;
                      @include mobile {
                        font-size: 36px;
                        margin-bottom: 7px;
                      }
                    }
                    i {
                      font-size: 12px;
                      font-weight: 300;
                      white-space: nowrap;
                    }
                  }
                }
              }
            }
            .btn {
              padding: 26px 0 22px;
              display: flex;
              justify-content: center;
              align-items: center;
              @include mobile {
                padding: 13px 0 11px;
              }
              label {
                width: 152px;
                height: 53px;
                border: 1px solid #5a5c5c;
                border-radius: 30px;
                display: flex;
                align-items: center;
                overflow: hidden;
                cursor: pointer;
                div {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  transition: transform .3s;
                  transition-timing-function: ease-in-out;
                  p {
                    width: 46px;
                    height: 46px;
                    background: url('~@/assets/images/icon/aircon-change-btn.png') no-repeat center;
                  }
                  span {
                    font-size: 18px;
                    font-weight: 600;
                    white-space: nowrap;
                    width: 102px;
                    display: block;
                    text-align: center;
                  }
                }
              }
              input:checked + label div {
                transform: translateX(-100px);
                p {
                  background: url('~@/assets/images/icon/heater-change-btn.png') no-repeat center;
                }
              }
            }
            &.heater {
              .temp .view ul li {
                &:first-child {
                  background: linear-gradient(to bottom, #e4a396, #efd19e);
                }
                &:last-child {
                  border: 1px solid #e4896e;
                }
                .icon {
                  background: #e4896e;
                }
              }
            }
            &.aircon {
              .temp .view ul li {
                &:first-child {
                  background: linear-gradient(to bottom, #82a6d1, #84c4d2);
                }
                &:last-child {
                  border: 1px solid #83a8d2;
                }
                .icon {
                  background: #6c94cd;
                }
              }
            }
          }

          .icon {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            p {
              font-size: 20px;
              font-weight: 900;
            }
            img {
              margin: 16px 0 18px;
              @include mobile {
                margin: 8px 0 9px;
              }
            }
            span {
              font-size: 17px;
              font-weight: 600;
            }
          }

          .info {
            width: 100%;
            border: 1px solid #424242;
            border-radius: 6px;
            overflow: hidden;
            margin-top: 17px;
            table {
              width: 100%;
              height: 100px;
              th, td {
                height: 43px;
                font-size: 15px;
                border-right: 1px solid #424242;
                border-bottom: 1px solid #424242;
                text-align: center;
              }
              thead th {
                background: #e7eff8;
                &:last-child {border-right: none;}
              }
              tbody {
                th {
                  color: #244c82;
                }
                tr:last-child {
                  td, th {
                    border-bottom: none;
                  }
                }
                td:last-child { border-right: none; }
              }
            }
          }
        }
      }
    }
  }
}
</style>
